import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/organisms/Header';
import TemplateCard from '../components/molecules/TemplateCard';
import Input from '../components/atoms/Input';
import Icon from '../components/atoms/Icon';

const TemplatesPage = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  
  const categories = ['All', 'Minimalist', 'Professional', 'Academic', 'Creative', 'Modern'];

  const requireAuth = () => {
    const token = localStorage.getItem('dutlaunch_token');
    const role = localStorage.getItem('dutlaunch_role');
    
    // If not logged in or not a candidate, redirect to login page
    if (!token || role !== 'candidate') {
      navigate('/login');
      return false;
    }
    return true;
  };
  
  // 10 Default Resume Templates
  const templates = [
    {
      id: 1,
      name: 'Modern Resume',
      category: 'Modern',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDXuPrn6SaXAiTefRaZTJGWEods692SWjccevUGAqimt3QNo1HHKnbPxMHGE-Wmq5l1BUKLPzqt_0xASa5F5o0Bv_K1eEs1cQEj-zBjv2MxtmDwIwwHn4c1sTFuFylA-zkvP3IY2dLrRnQu992fPIwcMpaIlXsozRiqf_0VOQMOqokZgxqpySSliuMRcFZKqMoyfr8L8yU2BjpRy1itrToeWloB3A97_Q2dV084Asm-Na-Lq6rABYy5ZGvt6q_4VEySXuOp6aC683k1',
      description: 'Clean and contemporary design perfect for tech professionals',
    },
    {
      id: 2,
      name: 'Creative Resume',
      category: 'Creative',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCMAwfPh0YvAw_lq71SBm4-PPTVoNzpgIB_MZ7Kgqh9DfbKqgxvoLW6qPwl9pQKfC-anZCgKh-0wrM-XuPEOhdaIhYpulwqewYprRpnUVXJugMgafkDCDkNlMzZXyDf9GmdPi7l96L-Qg1EA6FtwYixPBPdrEvJj59lcrYvnlqKqhbd-6hxnwM-jlYjDXYnWWJBFq_Ic7PVBCwoIYh67lHWLpiWTk7GF6s_Bvz73Rcxv25C-7UJ7oiIDT2swCWHgB8IK7bASNowKTDu',
      description: 'Bold and artistic layout for creative professionals',
    },
    {
      id: 3,
      name: 'Corporate Resume',
      category: 'Professional',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD8xgXuvZtvM9rNWqpCM5SAG92VIk4VYhGbeCpiAHOsvjVki0VF4njy4PSbNg1nTD-lDtnxQzrRrJAIIl2p61VfCHTl3Vg_Lbce8vndbM7Ze9Tr0Cvb8JXaWlO4aSElqt4amywHzN7GQ2JfhXFG4cBY342ZP5dzQMi79zF9YAlSBkQvNyPolwdjraU1WYu5ASmFJX0SMf37ELSrzNlyKI3sdJcMLB28RyGQb23msNDutLW8fs3sWjmd1v87l4d8zEtWVfxDZ_gfe4Ob',
      description: 'Traditional and formal design for corporate environments',
    },
    {
      id: 4,
      name: 'Chronological Classic',
      category: 'Professional',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBw_fPNv1DiZoZLd33E4r7arPgzoAuBQlI-NALAYRif2iJzX29yHczgkSQGtRl2sbVIYooB1P4Tn6ItQZq5BQB96wpUCnhPIbLHJvJjTsZXLp8VlTZmwpqjcL2pmPQDlZ06Oazxo6gjXvERkFrB2MnwrguKnXSW1PdIXC7TkU_SKNy1oexlYnko70BGTU0jyU3lN7orNG8a2ZU4ckiZ4veNOg8VoW-iKUM8XmPvqWRk2R4s_G4CWLgvu4gq93aoa2C1gv7peGoQBeWf',
      description: 'Timeline-based layout showcasing career progression',
    },
    {
      id: 5,
      name: 'Minimalist Resume',
      category: 'Minimalist',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDpNVhjn0vvOlloCe9sR6CF7RjN1dYH-qiVwRWPRyw_ye-j2y8bo4pcEKdi0wnzmFyoUfA0GObBYtKtl5Y4ll0W2e-nOvP_J7YcOOGjMO15huYhrg1gqNt8dBJXax1DK7Y-B7NV3r1UiiQiXHDAnl-8HcqCPrzfkdeKFhFLpg-GMibq1VLlSIVhA3wMblrU0oDo8O34UfTUkLE4NrSUQn9go2jxOd8DWi_jybjuUThxSOJomS1_OHyT6C8Eln9yfODKIYdMKjyq5A9J',
      description: 'Simple and elegant design with focus on content',
    },
    {
      id: 6,
      name: 'Portfolio Resume',
      category: 'Creative',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDXb9qwR3ncofdT4FptnBCozLxaumdNJ03ZVXgXT5OTrt8iKZTuHIFlvTgWBjHDjpnCLsQYi372lihDZoHVa5o2_kd7KI0aC_x5c47pMYeTrdwylgB-3AkoOcKNOmb2n8NpixCV6-M2FLupWQOZ9_lPOghlJqNsLajfE36GH-nT2BfPoaPJLDy6bqE2Lz8ktPyIEDCCCUaBAjtzGHixleaRuejXAVttHqtkoycxXtiLCXCbt2JXpvABupu3bkdRLAh57vYAf-MuYY8S',
      description: 'Showcase your work with this portfolio-style template',
    },
    {
      id: 7,
      name: 'Executive Resume',
      category: 'Professional',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD8xgXuvZtvM9rNWqpCM5SAG92VIk4VYhGbeCpiAHOsvjVki0VF4njy4PSbNg1nTD-lDtnxQzrRrJAIIl2p61VfCHTl3Vg_Lbce8vndbM7Ze9Tr0Cvb8JXaWlO4aSElqt4amywHzN7GQ2JfhXFG4cBY342ZP5dzQMi79zF9YAlSBkQvNyPolwdjraU1WYu5ASmFJX0SMf37ELSrzNlyKI3sdJcMLB28RyGQb23msNDutLW8fs3sWjmd1v87l4d8zEtWVfxDZ_gfe4Ob',
      description: 'Sophisticated design for senior-level positions',
    },
    {
      id: 8,
      name: 'Tech Professional',
      category: 'Modern',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDXuPrn6SaXAiTefRaZTJGWEods692SWjccevUGAqimt3QNo1HHKnbPxMHGE-Wmq5l1BUKLPzqt_0xASa5F5o0Bv_K1eEs1cQEj-zBjv2MxtmDwIwwHn4c1sTFuFylA-zkvP3IY2dLrRnQu992fPIwcMpaIlXsozRiqf_0VOQMOqokZgxqpySSliuMRcFZKqMoyfr8L8yU2BjpRy1itrToeWloB3A97_Q2dV084Asm-Na-Lq6rABYy5ZGvt6q_4VEySXuOp6aC683k1',
      description: 'Optimized for software engineers and tech roles',
    },
    {
      id: 9,
      name: 'Academic Resume',
      category: 'Academic',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBw_fPNv1DiZoZLd33E4r7arPgzoAuBQlI-NALAYRif2iJzX29yHczgkSQGtRl2sbVIYooB1P4Tn6ItQZq5BQB96wpUCnhPIbLHJvJjTsZXLp8VlTZmwpqjcL2pmPQDlZ06Oazxo6gjXvERkFrB2MnwrguKnXSW1PdIXC7TkU_SKNy1oexlYnko70BGTU0jyU3lN7orNG8a2ZU4ckiZ4veNOg8VoW-iKUM8XmPvqWRk2R4s_G4CWLgvu4gq93aoa2C1gv7peGoQBeWf',
      description: 'Perfect for researchers and academic positions',
    },
    {
      id: 10,
      name: 'Design Portfolio',
      category: 'Creative',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCMAwfPh0YvAw_lq71SBm4-PPTVoNzpgIB_MZ7Kgqh9DfbKqgxvoLW6qPwl9pQKfC-anZCgKh-0wrM-XuPEOhdaIhYpulwqewYprRpnUVXJugMgafkDCDkNlMzZXyDf9GmdPi7l96L-Qg1EA6FtwYixPBPdrEvJj59lcrYvnlqKqhbd-6hxnwM-jlYjDXYnWWJBFq_Ic7PVBCwoIYh67lHWLpiWTk7GF6s_Bvz73Rcxv25C-7UJ7oiIDT2swCWHgB8IK7bASNowKTDu',
      description: 'Visual-focused template for designers and artists',
    },
  ];
  
  const filteredTemplates = templates.filter(template => {
    const matchesCategory = selectedCategory === 'All' || template.category === selectedCategory;
    const matchesSearch = searchTerm === '' || 
      template.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  
  const handleUseTemplate = async (template) => {
    if (!requireAuth()) return;
    
    try {
      const candidateId = localStorage.getItem('dutlaunch_user_id');
      const candidateEmail = localStorage.getItem('dutlaunch_email');
      
      if (!candidateId || !candidateEmail) {
        alert('Please login to use templates');
        navigate('/login');
        return;
      }
      
      // Store template selection in localStorage for now
      localStorage.setItem('dutlaunch_resume_template', JSON.stringify({
        id: template.id,
        name: template.name,
        category: template.category,
        image: template.image
      }));
      
      // Show success message
      alert(`✓ Template "${template.name}" applied successfully! You can now edit your resume with this template.`);
      
      // Redirect to resume builder page
      navigate('/resume-builder');
    } catch (error) {
      console.error('Error applying template:', error);
      alert('Error applying template. Please try again.');
    }
  };
  
  const handlePreview = (template) => {
    if (requireAuth()) {
      console.log('Previewing template:', template.name);
      // Open preview modal or navigate to preview page
    }
  };
  
  return (
    <div className="relative flex h-auto min-h-screen w-full flex-col overflow-x-hidden">
      <Header />
      
      <main className="px-4 sm:px-10 lg:px-20 flex flex-1 justify-center py-5">
        <div className="flex flex-col w-full max-w-6xl flex-1">
          {/* Page Heading */}
          <div className="flex flex-wrap justify-between gap-4 p-4 text-center items-center flex-col">
            <div className="flex w-full flex-col gap-3">
              <h1 className="text-gray-900 dark:text-white text-4xl font-black leading-tight tracking-[-0.033em]">
                Select a Template to Get Started
              </h1>
              <p className="text-gray-500 dark:text-gray-400 text-base font-normal leading-normal max-w-2xl mx-auto">
                Our AI will help you populate your chosen design with your professional details, creating a standout resume in minutes.
              </p>
            </div>
          </div>
          
          {/* SearchBar and Category Chips */}
          <div className="flex flex-col md:flex-row gap-4 px-4 py-6 sticky top-[65px] bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-sm z-40">
            <div className="flex-grow">
              <div className="flex w-full flex-1 items-stretch rounded-xl h-12 shadow-sm">
                <div className="text-gray-500 dark:text-gray-400 flex border-r border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 items-center justify-center pl-4 rounded-l-xl">
                  <Icon name="search" />
                </div>
                <Input
                  type="text"
                  placeholder="Search for specific template styles or keywords"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="rounded-r-xl border-none bg-white dark:bg-gray-800 h-full px-4"
                />
              </div>
            </div>
            
            <div className="flex items-center gap-2 overflow-x-auto pb-2 -mb-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`flex h-12 shrink-0 items-center justify-center gap-x-2 rounded-xl px-4 transition-all ${
                    selectedCategory === category
                      ? 'bg-primary text-white'
                      : 'bg-white dark:bg-gray-800 shadow-sm text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-700'
                  }`}
                >
                  <p className="text-sm font-medium leading-normal whitespace-nowrap">
                    {category}
                  </p>
                </button>
              ))}
            </div>
          </div>
          
          {/* Templates Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-4">
            {filteredTemplates.map((template) => (
              <TemplateCard
                key={template.id}
                template={template}
                onUseTemplate={() => handleUseTemplate(template)}
                onPreview={() => handlePreview(template)}
              />
            ))}
          </div>
          
          {filteredTemplates.length === 0 && (
            <div className="flex flex-col items-center justify-center py-12 px-4">
              <Icon name="search_off" size={48} className="text-gray-400 mb-4" />
              <p className="text-gray-500 dark:text-gray-400 text-lg font-medium">
                No templates found matching your criteria
              </p>
              <p className="text-gray-400 dark:text-gray-500 text-sm mt-2">
                Try adjusting your search or category filter
              </p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default TemplatesPage;

